import { Button, Divider, Paper, Typography, useMediaQuery } from "@mui/material"
import { useAuth } from "../../../../context/SecurityContextProvider"
import ProPromoCard from "../../../../utils/subscription/ProPromoCard"

const TIER_MAPPING = {
    'LIGHT': { name: 'Light', price: 0, isMonthly: false },
    'STAR_LIGHT': { name: 'Starlight', price: 2.99, isMonthly: true },
    'LIGHT_MONTHLY': { name: 'Light', price: 3, isMonthly: true },
    'LIGHT_YEARLY': { name: 'Light', price: 30, isMonthly: false },
    'PRO_MONTHLY': { name: 'Pro', price: 8, isMonthly: true },
    'PRO_YEARLY': { name: 'Pro', price: 80, isMonthly: false },
    'DEFAULT': { name: 'Light', price: 0, isMonthly: false }
}

export default function SubscriptionSettings() {
    const { userData } = useAuth()
    const isMobile = useMediaQuery('(max-width:1050px)')
    const tierInfo = TIER_MAPPING[userData.tier] || TIER_MAPPING['DEFAULT']

    const styles = {
        paper: {
            p: 4,
            m: isMobile ? '1rem 0 0 0' : 2,
            borderRadius: '30px',
        },
        heading: {
            fontWeight: 600,
            fontFamily: "inherit",
        },
        featureHeading: {
            fontWeight: 600,
            mt: 2,
            mb: 1,
        },
        listItem: {
            fontWeight: 450,
            fontFamily: "inherit",
            p: '.2rem 0',
        },
        accountWarning: {
            fontWeight: 450,
            fontFamily: "inherit",
            fontSize: '90%',
            p: '.4rem',
            background: 'yellow',
            borderRadius: '12px',
        },
        manageButton: {
            fontSize: '.9rem',
            textTransform: 'none',
            m: '1rem .4rem',
            p: '.8rem 1rem',
            fontFamily: "inherit",
            width: '100%',
            background: 'primary.main',
            color: '#fcfcfc',
            borderRadius: '40px',
            boxShadow: "4px 5px 0px #000",
            "&:hover": {
                background: '#8c034c',
            }
        },
        priceSpan: {
            fontFamily: "sans-serif",
            fontWeight: 500
        }
    }

    return (
        <Paper elevation={3} sx={styles.paper}>
            <Typography variant="h6" component="h6" sx={styles.heading}>
                Account Details
            </Typography>

            <section>
                <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                    <li style={{ marginTop: '1rem' }}>
                        <Typography variant="body2" component="p" sx={styles.listItem}>
                            <strong>Current plan: </strong> {tierInfo.name}
                        </Typography>
                    </li>
                    {/* <li>
                        <Typography variant="body2" component="p" sx={styles.listItem}>
                            <strong>Price: </strong>
                            <span style={styles.priceSpan}>
                                {tierInfo.price === 0 ? 'Free' : `$${tierInfo.price}`}
                            </span>
                            {tierInfo.price > 0 && `/${tierInfo.isMonthly ? "month" : "year"}`}
                        </Typography>
                    </li> */}
                    <li>
                        <Typography variant="body2" component="p" sx={styles.listItem}>
                            <strong>Status: </strong>
                            {userData.hasActiveTier ? 'Active' : 'Not active 🔴'}
                        </Typography>
                        {!userData.hasActiveTier &&
                            <Typography variant="body2" component="p" sx={styles.accountWarning}>
                                Click 'manage my account' to activate your account.
                            </Typography>
                        }
                    </li>
                    <li>
                        <Typography variant="body2" component="p" sx={styles.listItem}>
                            <strong>Account email:</strong> {userData.email}
                        </Typography>
                    </li>
                </ul>
            </section>

            <Divider sx={{ my: 2 }} />

            <Button
                variant='contained'
                type='button'
                href="https://billing.stripe.com/p/login/bIY7sE4HJdpR5yw5kk"
                sx={styles.manageButton}
            >
                Manage My Account
            </Button>

            {tierInfo.name === 'Light' && <ProPromoCard />}

        </Paper>
    )
}
